import Vue from "vue";

import { axiosPlugin } from "@/plugins/axios_plugin";
Vue.use(axiosPlugin);

import { auth_plugin } from "@/plugins/auth_plugin";
Vue.use(auth_plugin);

import global_mixin from "@/mixins/global-mixin";
Vue.mixin(global_mixin);

import config from "@/config";
Vue.prototype.$config = config;

import eventbus from "@/eventbus";
Vue.prototype.$eventbus = eventbus;

import "@/components/index.js";
